<div class="overlay" *ngIf="loader.loading$ | async">
    <div class="spinner"></div>
</div>